if (!customElements.get('size-chart-loader')) {
  customElements.define('size-chart-loader', class SizeChartLoader extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.loading = null;
    }

    connectedCallback() {
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    onDocumentClick(event) {
      const opener = event.target.closest('modal-opener[data-modal]');
      const modal = this.closest('modal-dialog');
      if (!opener || !modal || opener.getAttribute('data-modal') !== `#${modal.id}`) return;
      if (!this.querySelector('size-chart-list') && !this.loading) this.load();
    }

    async load() {
      const status = this.querySelector('[data-size-chart-status]');
      if (status) status.textContent = this.dataset.loading || status.textContent;
      this.setAttribute('aria-busy', 'true');
      this.loading = (async () => {
        const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Size chart request failed: ${response.status}`);
        const sections = await response.json();
        const html = sections['size-chart-product'];
        const chart = html && new DOMParser().parseFromString(html, 'text/html').querySelector('size-chart-list');
        if (!chart) throw new Error('Size chart content was missing');
        const content = document.importNode(chart, true);
        const heading = content.querySelector('h1');
        if (heading) {
          const modalHeading = document.createElement('h2');
          for (const attribute of heading.attributes) modalHeading.setAttribute(attribute.name, attribute.value);
          modalHeading.replaceChildren(...heading.childNodes);
          heading.replaceWith(modalHeading);
        }
        const prefix = `loaded-sizechart-${crypto.randomUUID()}`;
        for (const input of content.querySelectorAll('input[name]')) input.name = `${prefix}-${input.name}`;
        this.replaceChildren(content);
      })();
      try {
        await this.loading;
      } catch (error) {
        if (status) status.textContent = this.dataset.error;
        this.dispatchEvent(new CustomEvent('sizechart:error', { bubbles: true, detail: error }));
      } finally {
        this.removeAttribute('aria-busy');
        this.loading = null;
      }
    }
  });
}
